import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'mlp-ng-header-alternative',
    templateUrl: './header.alternative.component.html',
    styleUrls: ['./header.alternative.component.scss']
})

export class HeaderAlternativeSharedComponent {
    @Input() header;
}
